export const filterRegion = data => data
export const focusChartShape = data => data
export const blurChartShape = data => data
export const toggleFixed = data => data



// WEBPACK FOOTER //
// ./src/actions/ui.js